










import { Vue, Component, Ref } from 'vue-property-decorator'
import store from 'src/assets/store'
import TopicPosts from 'components/presenter/item/forum/TopicPosts.vue'
import api from 'src/assets/api/gql'
import ForumTopicGet from 'src/graphql/forum/ForumTopicGet.gql'
import ForumTopicPosts from 'src/graphql/forum/ForumTopicPosts.gql'
import { ForumTopic } from 'src/graphql/types'

@Component({
  components: {
    TopicPosts
  }
})
export default class ItemForumTopic extends Vue {
  query = ForumTopicPosts
  topic: ForumTopic | null = null

  get item () {
    return store.state.presenter.item
  }

  @Ref()
  readonly posts!: TopicPosts

  async refresh (done: () => void) {
    const { data: { forumTopic } } = await api.query({
      query: ForumTopicGet,
      variables: { id: +this.$route.params.tid }
    })
    if (forumTopic) {
      this.topic = forumTopic
      this.$nextTick(async () => {
        await this.posts.refresh()
      })
    }
    done()
  }

  async load (index: number, done: (stop?: boolean) => void) {
    done(true)
  }
}
